import pen from "../../assets/images/luxury.png";
import booking from "../../assets/images/Bookings.png";
import glass from "../../assets/images/glass.png";
import plate from "../../assets/images/great_food.png";
import spas from "../../assets/images/spa_wellness.png";
import flight from "../../assets/images/plane.png";
import ship from "../../assets/images/Frame8.png";
import train from "../../assets/images/train.png";
import bus from "../../assets/images/bus.png";

export const notesTop = [
    { 
        id: "1",
        text: "General notes",
        img: pen,
        link: "",  
},
    {
        id: "2",
        text: "Booking informations",
        img: booking,
        link: "",
},
    {
        id: "3",
        text: "Nightlife",
        img: glass,
        link: "",
 },
{
        id: "4",
        text: "Restaurants",
        img: plate,
        link: "",
    },
{
        id: "5",
        text: "Spas",
        img: spas,
        link: "",
},
]
export const notesBottom = [
    { 
        id: "1",
        text: "Flight",
        img: flight,
        link: "",  
},
    {
        id: "2",
        text: "Ship/ferry",
        img: ship,
        link: "",
},
    {
        id: "3",
        text: "Train/Metro",
        img: train,
        link: "",
 },
{
        id: "4",
        text: "By bus",
        img: bus,
        link: "",
    },
]